/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualSalaryDto } from '../../models/backend-actual-salary-dto';
import { BackendPatchedActualSalaryRequestDto } from '../../models/backend-patched-actual-salary-request-dto';

export interface MonitoringActualsSalariesPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedActualSalaryRequestDto;
}

export function monitoringActualsSalariesPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsSalariesPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsSalariesPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualSalaryDto>;
    }),
  );
}

monitoringActualsSalariesPartialUpdate$FormData.PATH = '/api/monitoring/actuals/salaries/{id}/';
